import { useRESTv1, extendURLParams } from "@/utils/fetchData";
export const useInternetCitiesPerZipCode = (zipCode, opts, queryParams = {}) => {
    return useRESTv1(`/address/cities/${zipCode}`, extendURLParams(queryParams), opts);
};
